<template>
  <b-container class="py-4">
    <b-row>
      <b-col>
        <OrphanClaimsTable />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

import OrphanClaimsTable from "@components/OrphanClaims/OrphanClaimsTable";

export default defineComponent({
  name: "OrphanClaims",
  components: {
    OrphanClaimsTable,
  },
});
</script>
